import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ICmsServiceClassFeatureListResponse } from "../../Orchestrator/Types/Interface/ICmsServiceClassFeatureList";

export async function getCmsServiceClassFeatureList(): Promise<IApiResponse<ICmsServiceClassFeatureListResponse>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCmsServiceClassesAPI;

  const params = new URLSearchParams({
    locale: await getLocaleFromCookie(),
    "populate[service_class_feature_list][populate]": "true"
  });

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsServiceClassFeatureListResponse>(endpointWithParams, "GET");
}
